import React from 'react';
import { SanitizeHTML } from '../../../_helpers';
import { GoogleMapPopUP } from '../Common/GoogleMapPopUP';

const TextMessageAndSharedLocation = ({ displayMessage, lat, lng, isSenderMessage }) => {
    return (
        <div
            className={`${isSenderMessage ? 'sender-message d-flex justify-content-end text-justify px-3 py-2' : 'text-justify'}`}
        >
            {displayMessage === '' && lat && lng ? (
                <span>
                    shared a location: <GoogleMapPopUP lat={lat} lng={lng} />
                </span>
            ) : (
                <SanitizeHTML html={displayMessage} />
            )}
        </div>
    );
};

export default TextMessageAndSharedLocation;
